import React from "react"
import classnames from "classnames"
import { Section } from "AtomicComponents"
import styles from "./MyMazdaDashboard.less"
import componentParser from "AtomicUtils/componentParser";

class MyMazdaDashboard extends React.Component {
  render() {
    const { components } = this.props

    return (
      <Section backgroundColor="#F5F5F5" padding>
        <div className={classnames({
          [styles.MyMazdaDashboard]: true
        })}>
          {components && componentParser(components)}
        </div>
      </Section>
    )
  }
}

export default MyMazdaDashboard



// WEBPACK FOOTER //
// ./src/AtomicContainers/MyMazdaDashboard/MyMazdaDashboard.jsx